/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetUserSelfStatus200,
  GetUserSelfStatus400,
  GetUserSelfStatus404,
  GetUserSelfStatus500,
} from '../types/GetUserSelf'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getUserSelf } from '../clients/getUserSelf'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUserSelfQueryKey = () => [{ url: '/v1/user/self' }] as const

type GetUserSelfQueryKey = ReturnType<typeof getUserSelfQueryKey>

export function getUserSelfQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getUserSelfQueryKey()
  return queryOptions<
    GetUserSelfStatus200,
    ResponseErrorConfig<GetUserSelfStatus400 | GetUserSelfStatus404 | GetUserSelfStatus500>,
    GetUserSelfStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserSelf({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get user details for the authenticated user
 * {@link /v1/user/self}
 */
export function useGetUserSelf<
  TData = GetUserSelfStatus200,
  TQueryData = GetUserSelfStatus200,
  TQueryKey extends QueryKey = GetUserSelfQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUserSelfStatus200,
        ResponseErrorConfig<GetUserSelfStatus400 | GetUserSelfStatus404 | GetUserSelfStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUserSelfQueryKey()

  const queryResult = useQuery(
    {
      ...getUserSelfQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetUserSelfStatus400 | GetUserSelfStatus404 | GetUserSelfStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
